import { addToast } from '@octano/global-ui';
import { useHistory } from 'react-router';
import { Card, Col, Row } from 'reactstrap';
import GoBackButton from '../../../../components/buttons/GoBackButton';
import { useActionKitImp } from '../../../../components/ozmoit/common';
import { PathsLayouts } from '../../../../config/routes';
import { createSessionAction } from './actions';
import { SessionFormLoader } from './hooks/SessionFormLoader';
import useTexts from './hooks/useTexts';
import { FormCreate } from './parts/FormCreate';

export default function ContainerCreateCeia() {
  const texts = useTexts();
  const history = useHistory();

  const { action: handleOnSumbit } = useActionKitImp(createSessionAction, {
    onSuccess: () => {
      addToast({
        icon: 'success',
        color: 'success',
        text: texts.msg.success,
      });
      history.push(`${PathsLayouts.studentWarnings}/?tab=risk-evaluation`);
    },
    onError: {
      unknown: () => {
        addToast({
          icon: 'error',
          color: 'danger',
          text: texts.msg.error,
        });
      },
    },
  });

  return (
    <div className="mx-3">
      <Card className="p-4 mt-2 mx-3">
        <SessionFormLoader fetchImmediately>
          <Row>
            <Col xs={12} lg={6} className="mb-2">
              <GoBackButton text={texts.backToList} />
            </Col>
            <Col md={12} className="mb-4">
              <h2 className="text-primary fs-20 fw-700 mt-4 mb-2 text-uppercase">
                {texts.title}
              </h2>
            </Col>
            <FormCreate handleOnSumbit={handleOnSumbit} />
          </Row>
        </SessionFormLoader>
      </Card>
    </div>
  );
}
